import moment from "moment";
import { sideMenuConst } from "../constants/sideMenuConst";

export function getSideMenuCollpasedStateFromLocalStorage(
  time = moment().format()
) {
  return {
    type: sideMenuConst.GET_SIDE_MENU_TOGGLE_STATE_FROM_LOCALSTORAGE,
    time,
    // for localStorageManager middleware
    permanentStore: {
      required: true,
      storeKey: sideMenuConst.SIDEMU_IS_COLLAPSED_KEY,
      storeValue: "",
      ReadOrWrite: sideMenuConst.READ_LOCALSTORAGE // write key / value to localStorage
    }
  };
}
export function openSideMenu(time = moment().format()) {
  return {
    type: sideMenuConst.OPEN_SIDE_MENU,
    isCollapsed: false,
    time,
    // for localStorageManager middleware
    permanentStore: {
      required: true,
      storeKey: sideMenuConst.SIDEMU_IS_COLLAPSED_KEY,
      storeValue: sideMenuConst.SIDEMU_IS_NOT_COLLAPSED_VALUE,
      ReadOrWrite: sideMenuConst.WRITE_LOCALSTORAGE // write key / value to localStorage
    }
  };
}
export function closeSideMenu(time = moment().format()) {
  return {
    type: sideMenuConst.CLOSE_SIDE_MENU,
    isCollapsed: true,
    time,
    // for localStorageManager middleware
    permanentStore: {
      required: true,
      storeKey: sideMenuConst.SIDEMU_IS_COLLAPSED_KEY,
      storeValue: sideMenuConst.SIDEMU_IS_COLLAPSED_VALUE,
      ReadOrWrite: sideMenuConst.WRITE_LOCALSTORAGE // write key / value to localStorage
    }
  };
}
export function toggleSideMenu() {
  return (dispatch, getState) => {
    const state = getState();
    const sideMenuStore = state.sideMenu;
    if (sideMenuStore.isCollapsed) {
      dispatch(openSideMenu());
    } else {
      dispatch(closeSideMenu());
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/sideMenu.js